// safeUrl.ts
// Helpers para sanitizar URLs antes de renderizarlas como `<a href>`,
// `<video src>`, `<iframe src>` o `window.open`.
//
// Si una URL viene corrupta de la DB o de un campo manipulado por un
// admin malicioso (ej. `javascript:alert(...)`, `data:text/html,...`),
// renderizarla directo es XSS. La whitelist de schemes corta el vector
// y mapea cualquier URL inválida a `about:blank`. Ver
// docs/seguridad.md §0.0 (round 2026-04-26, P1-I).
import { API_BASE_URL } from "../services/apiClient";

/**
 * Resuelve y sanea una URL que viene de la API:
 *   - http://… o https://… → la devuelve tal cual.
 *   - "/path/relativo"   → prepende el origin del backend (strip `/api`).
 *   - cualquier otra cosa (`javascript:`, `data:`, vacía, undefined) →
 *     `about:blank`.
 */
export function resolveFileUrl(url: string | null | undefined): string {
  if (typeof url !== "string" || !url) return "about:blank";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (!url.startsWith("/")) return "about:blank";
  const origin = API_BASE_URL.replace(/\/api$/, "");
  return `${origin}${url}`;
}
